import React, { memo } from 'react'

import {
  FieldError, FormGrid, FormLabel, FormRow, FormSection, SelectInput, TextArea, TextInput
} from '../../components/ui'
import { OPCOES_GENERO } from '../../constants/genero'

/* Cadastro do paciente. A casca do modal vem do FormModal.

   A parte de baixo é a ficha de saúde — o que o médico lê antes da consulta.
   Alergia, histórico familiar e medicamento contínuo são texto livre, um por
   linha: é o mesmo formato do app, e a API transforma cada linha em registro
   do catálogo (reaproveitando o que já existe com aquele nome).

   As listas de opções vêm de `/get-constants/`, a mesma fonte que o app e o
   portal usam — assim ninguém digita "O+" num lugar e "O positivo" no outro. */

const Campo = ({ label, name, full, values, errors, touched, handleChange, handleBlur, ...rest }) => (
  <FormRow $full={full}>
    <FormLabel>{label}</FormLabel>
    <TextInput
      autoComplete='nope'
      name={name}
      value={values[name] || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      $error={!!errors[name]}
      {...rest}
    />
    <FieldError>{touched[name] && errors[name]}</FieldError>
  </FormRow>
)

const Escolha = ({ label, name, opcoes = [], values, handleChange, handleBlur }) => (
  <FormRow>
    <FormLabel>{label}</FormLabel>
    <SelectInput name={name} value={values[name] || ''} onChange={handleChange} onBlur={handleBlur}>
      <option value=''>Selecione</option>
      {opcoes.map(o => <option key={o.id} value={o.id}>{o.name}</option>)}
    </SelectInput>
    <FieldError />
  </FormRow>
)

const Lista = ({ label, name, placeholder, values, handleChange, handleBlur }) => (
  <FormRow $full>
    <FormLabel>{label}</FormLabel>
    <TextArea
      name={name}
      value={values[name] || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={placeholder}
    />
    <FieldError />
  </FormRow>
)

const Form = ({
  isCreating = false, values, errors, touched, handleChange, handleBlur,
  constantes = {}, planos = []
}) => {
  const props = { values, errors, touched, handleChange, handleBlur }
  const escolha = { values, handleChange, handleBlur }

  return (
    <FormGrid>
      <FormSection>Identificação</FormSection>

      <Campo label='Nome' name='name' full {...props} />
      <Campo label='E-mail' name='login' type='email' {...props} />
      {isCreating && <Campo label='Senha' name='password' type='password' {...props} />}
      <Campo label='CPF' name='cpf' inputMode='numeric' placeholder='Somente números' {...props} />
      <Campo label='Data de nascimento' name='birth_date' type='date' {...props} />
      <Campo label='Celular' name='cellphone' placeholder='(00) 00000-0000' {...props} />

      <FormRow>
        <FormLabel>Gênero</FormLabel>
        <SelectInput name='gender' value={values.gender || ''} onChange={handleChange} onBlur={handleBlur}>
          <option value=''>Selecione</option>
          {OPCOES_GENERO.map(o => <option key={o.valor} value={o.valor}>{o.rotulo}</option>)}
        </SelectInput>
        <FieldError />
      </FormRow>

      <Escolha label='Orientação sexual' name='orientation' opcoes={constantes.orientations} {...escolha} />
      <Escolha label='Etnia' name='ethnicity' opcoes={constantes.ethnicities} {...escolha} />

      <FormSection>Plano de saúde</FormSection>

      <Escolha label='Plano' name='health_insurance' opcoes={planos} {...escolha} />
      <Campo label='Outro plano' name='other_health_insurance'
        placeholder='Se o plano não estiver na lista' {...props} />

      <FormSection>Ficha de saúde</FormSection>

      <Escolha label='Tipo sanguíneo' name='blood_type' opcoes={constantes.blood_types} {...escolha} />
      <Escolha label='Fator RH' name='rh_factor' opcoes={constantes.rh_factors} {...escolha} />
      <Escolha label='Alimentação' name='alimentation' opcoes={constantes.alimentations} {...escolha} />
      <Escolha label='Atividade física' name='physical_activity' opcoes={constantes.physical_activities} {...escolha} />
      <Escolha label='Cigarro' name='smoke' opcoes={constantes.smokes} {...escolha} />
      <Escolha label='Álcool' name='alcohol' opcoes={constantes.alcohols} {...escolha} />
      <Escolha label='Drogas' name='drug' opcoes={constantes.drugs} {...escolha} />

      <Lista label='Alergias' name='allergies' placeholder={'Uma por linha\nEx.: Dipirona'} {...escolha} />
      <Lista label='Histórico familiar' name='family_history'
        placeholder={'Uma por linha\nEx.: Diabetes'} {...escolha} />
      <Lista label='Medicamentos contínuos' name='continuous_medications'
        placeholder={'Um por linha\nEx.: Losartana 50mg'} {...escolha} />
    </FormGrid>
  )
}

export default memo(Form)
